<template>
    <div class="page-news-detail">
        <content-item :title="$t('news')">
            <router-link to="/news" class="back-list">
                返回列表
            </router-link>
            <div class="news-header">
                <h2 class="news-header-title">{{ res.title }}</h2>
                <p class="news-header-date">{{ res.reporter }} • {{ res.news_date }}</p>
            </div>
            <div class="news-detail-content"  v-html="res.content">

            </div>
            <!--<div class="news-origin">-->
                <!--<a :href="res.url" target="_blank">阅读原文</a>-->
            <!--</div>-->
        </content-item>
    </div>
</template>

<script>
    import ContentItem from './partial/ContentItem.vue'
    import md5 from 'blueimp-md5'
    import globals from '../config/global'


    export default{
        data() {
            return {
                res:[]
            };
        },
        computed: {

        },
        beforeMount(){
            let id = this.$route.params.id
            let timeStamp = Date.parse(new Date());
            let sign = md5(timeStamp)
            let extraParam = '&platform=2'//1英卓，2萌果
            if(globals.isTest){//测试环境会获取未审核的内容
                extraParam += '&isTest=1'
            }
            this.$http.get(globals.enjoyUrl + 'enjoysiteapi/getnews?id='+id+'&timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(
                function (response) {
                    this.res= response.data

                });


        },
        components: {
            ContentItem
        }
    };
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib";

    .page-news-detail {
        margin-top: 30px;
    }

    .back-list {
        color: $orange-color;
        text-decoration: none;
        position: absolute;
        right: 39px;
        top: 26px;
    }

    .news-header {
        width: 100%;
        text-align: center;
        .news-header-title {
            font-size: 26px;
        }
        .news-header-date {
            color: gray;
            margin-top: 20px;
        }
    }

    .news-origin {
        width: 100%;
        margin: 0 auto 30px;
        text-align: center;
        a {
            text-align: center;
            font-size: 18px;
            color: $orange-color;
            cursor: pointer;
            &:hover {

            }
        }
    }
</style>



// WEBPACK FOOTER //
// NewsDetail.vue?0c48d008